export const LeaderReportType = {
  NORMAL: 'NORMAL',
  TWOMACHINE: 'TWOMACHINE',
  PREMIUM: 'PREMIUM',
  OVERTIME: 'OVERTIME',
  TWOMACHINE40: 'TWOMACHINE40',
};

export const LeaderReportTypeList = [
  { label: 'Normál', value: LeaderReportType.NORMAL },
  { label: 'Két gépes pótlék 25%', value: LeaderReportType.TWOMACHINE },
  { label: 'Két gépes pótlék 40%', value: LeaderReportType.TWOMACHINE40 },
  { label: 'Prémium', value: LeaderReportType.PREMIUM },
  { label: 'Túlóra', value: LeaderReportType.OVERTIME },
];

export const LeaderReportShift = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
};

export const LeaderReportShiftList = [
  { label: '1', value: LeaderReportShift.FIRST },
  { label: '2', value: LeaderReportShift.SECOND },
  { label: '3', value: LeaderReportShift.THIRD },
];

export const LeaderReportActivity = {
  FREEDOM: 'FREEDOM',
  POCKETMONEY: 'POCKETMONEY',
  CERTIFIED: 'CERTIFIED',
  PAID_HOLIDAY: 'PAID_HOLIDAY',
  TMK: 'TMK',
  KFT: 'KFT',
  NOT_CERTIFIED: 'NOT_CERTIFIED',
};

export const LeaderReportActivityList = [
  { label: 'Szabadság', value: LeaderReportActivity.FREEDOM },
  { label: 'Táppénz', value: LeaderReportActivity.POCKETMONEY },
  { label: 'Ig. Táv', value: LeaderReportActivity.CERTIFIED },
  { label: 'Fiz. Ünnep', value: LeaderReportActivity.PAID_HOLIDAY },
  { label: 'TMK', value: LeaderReportActivity.TMK },
  { label: 'KFT. Ált.', value: LeaderReportActivity.KFT },
  { label: 'Nem igazolt', value: LeaderReportActivity.NOT_CERTIFIED },
];

export const DownTimeType = {
  DRAWING_ERROR: 'DRAWING_ERROR',
  MATERIAL_SHORTAGE: 'MATERIAL_SHORTAGE',
  MACHINE_ERROR: 'MACHINE_ERROR',
  JOB_SHORTAGE: 'JOB_SHORTAGE',
  OTHER: 'OTHER',
};

export const DownTimeTypeList = [
  { label: 'Rajz hiba', value: DownTimeType.DRAWING_ERROR },
  { label: 'Alapanyag hiány', value: DownTimeType.MATERIAL_SHORTAGE },
  { label: 'Géphiba', value: DownTimeType.MACHINE_ERROR },
  { label: 'Munkahiány', value: DownTimeType.JOB_SHORTAGE },
  { label: 'Egyéb', value: DownTimeType.OTHER },
];
